import React from 'react';
import MatchTable from '../Common/MatchTable';
import { Remark } from '../Common/MatchBase';

const FHL = () => {
    return (
        <section className='FHL'>
            <MatchTable betType='FHL' />
            <Remark />
        </section>
    )
}
export default FHL;